import { API_FILE_PREFIX } from '@shared/config/api/api-prefixes';
import { inputFileSearchBaseApi } from './base';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { FilesListDataRequest, FilesListDataResponse } from '@shared/api/file/file-types';
import { isEqualParameters } from '@shared/lib/utils/is-equal-parameters/is-equal-parameters';

export const inputFileSearchApi = inputFileSearchBaseApi.injectEndpoints({
    endpoints: (build) => ({
        filesInfinityList: build.query<FilesListDataResponse, FilesListDataRequest>({
            query: (parameters) => `${API_FILE_PREFIX}${queryParametersToString({ ...parameters })}`,
            serializeQueryArgs: (params) => {
                return `${params.endpointName}_${params.queryArgs.search}`;
            },
            merge: (currentCache, newItems) => {
                if (newItems.skip) {
                    currentCache.items.push(...newItems.items);
                }
            },
            forceRefetch({ currentArg, previousArg }) {
                return !isEqualParameters({ currentParameters: currentArg, previousParameters: previousArg });
            },
        }),
    }),
});

export const { useFilesInfinityListQuery } = inputFileSearchApi;
